import axios from './axiosInterceptors';
import authHeader from "./authentification-header";
import { saveAs } from 'file-saver';

const API_URL = "/api/v1/";

const getTankMidnightByDate = (filterData) => {
    return axios.post(API_URL + 'tank-midnight/filters/', filterData)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const updateTankData = (updateData) => {
    return axios.post(API_URL + 'tank-midnight/update', updateData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const submitTankData = (submitData) => {
    return axios.post(API_URL + 'tank-midnight/submit', submitData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const generateExcel = (data) => {
    return axios.post(API_URL + 'tank-midnight/exportExcel', data, {responseType: 'blob'})
        .then((response) => {
            let filename = `TankMidnight ${data[0].movementDate.toString().substring(0, 10)}.xlsx`
            let blob = new Blob([response.data]);
            saveAs(blob, filename);
            return 'excel saved';
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err)
        })
}

const allActions = {
    getTankMidnightByDate,
    updateTankData,
    submitTankData,
    generateExcel
};

export default allActions;